module.exports = __webpack_public_path__ + "saving.be02d5ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/community_tabs/saving.png
// module id = 360
// module chunks = 0